import { V } from '@angular/cdk/keycodes';
import { Component, Input, ElementRef, AfterViewInit, ViewChild } from '@angular/core';

@Component({
  selector: 'agent-builder-log-detail-expandable',
  templateUrl: './agent-builder-messages-log-detail-expandable.component.html',
  styleUrls: ['./agent-builder-messages-log-detail-expandable.component.scss'],
  standalone: false
})
export class AgentBuilderMessagesLogDetailExpandableComponent implements AfterViewInit {

  @Input() text: string = '';
  @Input() maxLines: number = 4;

  @ViewChild('contentEl') contentEl!: ElementRef;
  @ViewChild('containerEl') containerEl!: ElementRef;

  expanded = false;
  needsToggle = false;

  ngAfterViewInit() {
    setTimeout(() => {
      const el = this.containerEl.nativeElement as HTMLElement;

      const style = getComputedStyle(el);
      let lineHeight = parseFloat(style.lineHeight);

      // fallback se vier "normal" ou NaN
      if (isNaN(lineHeight)) {
        const fontSize = parseFloat(style.fontSize) || 14;
        lineHeight = fontSize * 1.4; // mesmo 1.4 do CSS
      }

      const maxHeight = this.maxLines * lineHeight;

      if (el.scrollHeight > maxHeight + 5) {
        this.needsToggle = true;
      }
    });
  }
  getBubbleElement(): HTMLElement | null {
    let el: HTMLElement | null = this.containerEl.nativeElement;

    while (el && el.parentElement) {
      el = el.parentElement;

      // Garante que é o bubble PAI, não outro bubble qualquer
      if (el.classList.contains('bubble')) {
        return el;
      }
    }

    return null;
  }
  
  getScrollContainer(el: HTMLElement): HTMLElement {
  let parent: HTMLElement | null = el.parentElement;

  while (parent) {
    // O scroll REAL está no elemento customizado
    if (parent.tagName.toLowerCase() === 'agent-builder-messages-log-detail') {
      return parent;
    }

    parent = parent.parentElement;
  }

  throw new Error('Scroll container <agent-builder-messages-log-detail> não encontrado');
}


private getOffsetRelativeTo(el: HTMLElement, parent: HTMLElement): number {
  let y = 0;
  let node: HTMLElement | null = el;

  while (node && node !== parent) {
    y += node.offsetTop;
    node = node.offsetParent as HTMLElement | null;
  }

  return y;
}

 toggle() {
    const bubbleEl = this.getBubbleElement();
    if (!bubbleEl) return;

    const scrollContainer = this.getScrollContainer(bubbleEl);

    this.expanded = !this.expanded;

    requestAnimationFrame(() => {
      const bubbleTop = this.getOffsetRelativeTo(bubbleEl, scrollContainer);
      scrollContainer.scrollTo({ top: bubbleTop, behavior: 'smooth' });
    });
  }


}